module.exports = __webpack_public_path__ + "static/media/avatars_other_27.1f3da0c1.png";